import { render, staticRenderFns } from "./GroupGuide.vue?vue&type=template&id=28eb1524"
import script from "./GroupGuide.vue?vue&type=script&lang=js"
export * from "./GroupGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports